/**
 * 操作状态
 */

/**
 * 设置问题列表
 * @param  {[type]} state [description]
 * @param  {[type]} list  [description]
 * @return {[type]}       [description]
 */
export const repairedAccount_setQuestList = (state, list) => {
  state.quest.list = list;
};

/**
 * 设置地区列表
 * @param  {[type]} state [description]
 * @param  {[type]} list  [description]
 * @return {[type]}       [description]
 */
export const repairedAccount_setAreaList = (state, list) => {
  state.area.list = list;
};

/**
 * 设置补充资料选项
 * @param  {[type]} state      [description]
 * @param  {[type]} addOptions [description]
 * @return {[type]}            [description]
 */
export const repairedAccount_setAddOptions = (state, addOptions) => {
  state.addOptions = addOptions;
};

/**
 * 设置账号修复选项
 * @param  {[type]} state      [description]
 * @param  {[type]} repairOptions [description]
 * @return {[type]}            [description]
 */
export const repairedAccount_setRepairOptions = (state, repairOptions) => {
  state.repairOptions = repairOptions;
};

/**
 * 设置当前操作步骤
 * @param  {[type]} state      [description]
 * @param  {[type]} curProcess [description]
 * @return {[type]}            [description]
 */
export const repairedAccount_setCurProcess = (state, curProcess) => {
  state.curProcess = curProcess;
};

/**
 * 设置申请结果
 * @param  {[type]} state [description]
 * @param  {[type]} list  [description]
 * @return {[type]}       [description]
 */
export const repairedAccount_setApplyResult = (state, res) => {
  state.applyResult = res;
};

/**
 * 设置查询结果
 * @param  {[type]} state [description]
 * @param  {[type]} res   [description]
 * @return {[type]}       [description]
 */
export const repairedAccount_setQueryResult = (state, res) => {
  state.queryResult = res;
};

/**
 * 设置补充结果
 * @param  {[type]} state [description]
 * @param  {[type]} res   [description]
 * @return {[type]}       [description]
 */
export const repairedAccount_setAddResult = (state, res) => {
  state.addResult = res;
};

/**
 * 设置邮件验证码发送状态
 * @param  {[type]} state [description]
 * @param  {[type]} res   [description]
 * @return {[type]}       [description]
 */
export const repairedAccount_setEmailSendStatus = (state, res) => {
  state.emailSendStatus = res;
};

/**
 * 设置重置密码状态
 * @param  {[type]} state [description]
 * @param  {[type]} res   [description]
 * @return {[type]}       [description]
 */
export const repairedAccount_setResetPwdStatus = (state, res) => {
  state.resetPwdStatus = res;
};

/**
 * 设置重置邮箱状态
 * @param  {[type]} state [description]
 * @param  {[type]} res   [description]
 * @return {[type]}       [description]
 */
export const repairedAccount_setResetEmailStatus = (state, res) => {
  state.resetEmailStatus = res;
};

/**
 * 设置重置安全问题状态
 * @param  {[type]} state [description]
 * @param  {[type]} res   [description]
 * @return {[type]}       [description]
 */
export const repairedAccount_setResetQuestStatus = (state, res) => {
  state.resetQuestStatus = res;
};

/**
 * 显示弹窗状态
 * @param  {[type]} state [description]
 * @param  {[type]} res   [description]
 * @return {[type]}       [description]
 */
export const repairedAccount_setDialogs = (state, text) => {
  state.dialogs = {
    status: true,
    text: text,
  };
  // setTimeout(function () {
  //     state.dialogs.status = !state.dialogs.status
  // }, 2000)
};

// 隐藏弹窗
export const repairedAccount_hideDialogs = state => {
  state.dialogs.status = false;
};
